import { FLAGS_WITH_RULES } from "../constants";

export function getFeatureFlagValue(feature) {
  const flagValue = Boolean(feature.value?.enabled);

  if (FLAGS_WITH_RULES.includes(feature.name)) {
    return feature.value;
  }

  return flagValue;
}
